import { render } from "./forgotten-password.vue?vue&type=template&id=52c07d66&ts=true"
import script from "./forgotten-password.vue?vue&type=script&lang=ts"
export * from "./forgotten-password.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__